import { identityServiceUrl } from "@/api/identityApi";

// After a successful sign-in / sign-up, the browser is navigated back to
// `returnUrl`. The URL comes in via a query param. We accept only:
//   1. A path starting with `/` (no scheme) — treated as a path on the
//      identity-service origin so `/connect/authorize?...` completes the OIDC
//      flow the user originally came from.
//   2. An absolute URL whose origin matches the identity-service origin.
// Anything else is rejected (falls back to the identity-web root) to avoid
// open-redirector abuse.
export function resolveSafeReturnUrl(raw: string | null): string {
    if (!raw) return "/";
    if (raw.startsWith("/") && !raw.startsWith("//")) {
        return new URL(raw, identityServiceUrl).toString();
    }
    try {
        const target = new URL(raw);
        const allowed = new URL(identityServiceUrl);
        if (target.origin === allowed.origin) {
            return target.toString();
        }
    } catch {
        // invalid URL — fall through
    }
    return "/";
}
